import { useMemo } from "react";
import { useRequest } from "ahooks";
import { getAlarmPolicyList } from "@/apis/apiCollection";
import SingleSelector from "../SingleSelector";
import { useTranslation } from "@/langs/useTranslation";

// const useDefaultStatePlugin = () => {
//   return {};
// };

// useDefaultStatePlugin.onInit = () => {
//   return {
//     data: { alarm_policy_options: [] }
//   };
// };

let cachedData = [];

export const useAlarmRuleList = () => {
  const { data = [] } = useRequest(async () => {
    if (!cachedData.length) {
      const res = await getAlarmPolicyList({ hasOfflineOption: 1 });
      cachedData = res.alarm_policy_options;
      return cachedData;
    }
    return cachedData;
  });

  return data;
};

const AlarmRuleList = ({ excludes = [], disabled, name, value, onChange }) => {
  const { t } = useTranslation();

  const data = useAlarmRuleList();

  const options = useMemo(() => {
    return data
      .map(item => ({
        id: item.id,
        name: t(item.name)
      }))
      .filter(item => !excludes.includes(item.id));
  }, [data, excludes]);

  const handleChange = e => {
    onChange?.(e, data.find(option => option.id === e.target.value) || {});
  };

  return (
    <SingleSelector
      placeholder={t({ defaultMessage: "报警规则" })}
      disabled={disabled}
      options={options}
      clearable
      style={{ width: 200 }}
      name={name}
      value={value}
      onChange={handleChange}
    />
  );
};

export default AlarmRuleList;
